import { useTranslation } from "react-i18next";

import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";
import { warnOnMismatchedContentType } from "utils/common";

type UploadInterventionAttachmentPayload = {
  appointment_id: number;
  file: File;
};

export const useUploadInterventionAttachmentMutation = () => {
  const { t } = useTranslation();

  return useTypedMutation({
    mutationFn: async ({ appointment_id, file }: UploadInterventionAttachmentPayload) => {
      const formData = new FormData();
      formData.append("appointment_id", String(appointment_id));
      formData.append("file", file);

      return (await ApiInstance.post("/interventions/attachment/upload", formData)).data.url;
    },
    onSuccess: ({ file }, url: string) => warnOnMismatchedContentType(file.name, url, t)
  });
};
